import { MessageEventBus } from "../../../event-bus";
import JSZip from "jszip";
import { ErrorHandler } from "../error-handler";

export class GeneratorDownloadService {
  private errorHandler = new ErrorHandler("Code generation");

  isFolderPickerSupported(): boolean {
    /* @ts-expect-error tbd */
    return typeof window.showDirectoryPicker !== "undefined";
  }

  private async writeToFolder(dirHandle: FileSystemDirectoryHandle, files: Record<string, string>) {
    for (const path in files) {
      const segments = path.split("/").filter((s) => s.length > 0);
      const fileName = segments.slice(-1)[0];
      let currentHandle: FileSystemDirectoryHandle = dirHandle;
      if (segments.length > 1) {
        for (const dir of segments.slice(0, -1)) {
          currentHandle = await currentHandle.getDirectoryHandle(dir, { create: true });
        }
      }
      const fileHandle = await currentHandle.getFileHandle(fileName, { create: true });
      const writable = await fileHandle.createWritable();
      await writable.write(files[path]);
      await writable.close();
    }
  }

  private createZip(files: Record<string, string>) {
    const zip = new JSZip();
    for (const file in files) {
      zip.file(file, files[file]);
    }
    return zip.generateAsync({ type: "blob" });
  }

  private downloadToDefaultTarget(content: Blob, fileName: string) {
    const href = URL.createObjectURL(content);
    const link = document.createElement("a");
    link.href = href;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async handleGenerate(
    res: { data: Record<string, string> },
    modelName: string,
    id: string,
    targetDirectoryHandle?: FileSystemDirectoryHandle
  ) {
    try {
      if (targetDirectoryHandle) {
        await this.writeToFolder(targetDirectoryHandle, res.data);
      } else {
        const fileName = modelName + "-code.zip";
        this.createZip(res.data).then((blob) => this.downloadToDefaultTarget(blob, fileName));
      }
      MessageEventBus.emit("success", {
        text: "Code generation successful.",
        id: id,
      });
    } catch (error) {
      this.errorHandler.handle(error, id, "Code generation failed.");
    }
  }
}
